module.exports = __webpack_public_path__ + "img/n-icon.6fd34943.svg";